<template>
  <div>
    <div
      v-for="item in fileLists"
      :key="item.url"
      class="file-box"
      @click="previewUrl(item.url)"
    >
      <div class="left">
        <img
          class="left-icon"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220513/81d5190d620358b9bd09c0b7c6a4cb07.svg"
          alt=""
        />
        <div class="file-title">{{ item.title }}</div>
      </div>
      <!-- <icon
        class="clear"
        color="#999999"
        type="clear"
        size="7.5"
        v-if="edit"
        @click="clear"
        :data-type="title"
      /> -->
      <img
        class="previee-icon"
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
        mode="aspectFill"
      />
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { isMobile } from "@/utils/common";

export default {
  props: {
    fileLists: {
      type: Array,
      default: []
    },
    desc: {
      type: String,
      default: "微信扫一扫，前往升级权限"
    },
    clickBack: {
      type: Boolean,
      default: false
    },
    jumpAble: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return{
      isMobile: isMobile()
    }
  },
  methods: {
    previewUrl(url) {
      if (url) {
        if (this.jumpAble) {
          if(this.isMobile) {
            window.location.href = url;
          }else {
            window.open(url)
          }
        } else {
          Dialog.alert({
            title: "",
            message: "提交后在答案与解析中查看，或在小程序里作答时可查看",
            confirmButtonText: "我知道了",
            confirmButtonColor: "#1890FF",
            showCancelButton: false
          }).then(() => {});
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-box {
  height: 78px;
  background: #f8f8f8;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: pointer;
}

.file-box .left {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.file-box .left-icon {
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 2px;
  margin-right: 10px;
  object-fit: contain;
}

.file-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.previee-icon {
  width: 8px;
  height: 12.5px;
  min-width: 8px;
  margin-left: 10px;
}
.parsing-items-cover {
  width: 60px;
  height: 60px;
  min-width: 60px;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: #ffffff;
  box-sizing: border-box;
  color: #666666;
  font-size: 12px;
  text-align: center;
  margin-right: 10px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/gzhfile.vue